// if(res.data[i]['module'] == 'delivery')
// window.location.href = '/delivery/general'

import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
export class DSearchInModule extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      visitid: "",
      DataLoaded: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleRowClick(patient) {
    $(".patientDetails").show();
    $(".startTreatment").attr("id", patient.visitid);
    var details =
      patient.Name + " (" + patient.Age + ")- " + patient.Nationality;
    $(".patientName").text(details);
    var visitId = patient.visitid.split("_");
    var serialNumber = visitId[1];
    var visitNumber = visitId[2];

    $(".NumberOfVisit").text(visitNumber);
    $(".SerialNumber").text(serialNumber);

    // {
    //     label: "Number of Visit",
    //     field: "EvolutionAndTreatment",
    //     sort: "asc",
    //     width: 50
    // },
    // {
    //     label: "Serial Number",
    //     field: "EvolutionAndTreatment",
    //     sort: "asc",
    //     width: 50
    // },
  }

  componentDidMount() {
    $(".patientDetails").hide();
    $(".startTreatment").on("click", function () {
      var visitId = $(this).attr("id");
      // alert(visitId)

      localStorage.setItem("currentVisitId", visitId);
      const headers = {
        "Content-Type": "application/json",
        token: localStorage.getItem("accessToken"),
        visitid: visitId,
      };
      console.log(localStorage.getItem("accessToken"));
      axios
        .get(this.api_url+"reception/onepatient", { headers: headers })
        .then((res) => {
          //   const verified = res.data;
          console.log(res.data[0]["Name"]);

          localStorage.setItem("currentVisitName", res.data[0]["Name"]);
          localStorage.setItem(
            "currentVisitNationality",
            res.data[0]["Nationality"]
          );
          localStorage.setItem(
            "currentVisitProfession",
            res.data[0]["Profession"]
          );
          localStorage.setItem("currentVisitAge", res.data[0]["Age"]);
        })
        .catch((error) => {
          console.log(error);
        });

      if (localStorage.getItem("currentVisitAge")) {
        console.log(localStorage.getItem("currentSpecialty"));
        localStorage.setItem("currentModule", "delivery");
        $(".alert-succes").show();
        window.location.href = "/delivery/general";
      }
    });

    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    axios
      .get(this.api_url+"billing/status/triage/open", { headers: headers })
      .then((res) => {
        //   const verified = res.data;
        // console.log(res.data[0]['module'])
        let tableinit = new Array();
        for (var i = 0; i < res.data.length; i++) {
          console.log(res.data[i]);
          if (res.data[i]["status"] == true) {
            console.log(res.data[i]["name"]);
            if (res.data[i]["module"] == "delivery") {
              var number = i + 1;
              // console.log()
              var split = res.data[i]["timeofopen"].split(" ");
              var date = split[0];
              var time = split[1];

              tableinit.push(res.data[i]);

              // console.log(typeof(table))
              let object = {};
              for (let i = 0; i < tableinit.length; i++) {
                delete tableinit[i]._id;
                delete tableinit[i].timeOfRegistration;
                tableinit[i].clickEvent = () =>
                  this.handleRowClick(tableinit[i]);
              }
              // table = JSON.stringify(table);
              var visitId = res.data[i]["visitid"].split("_");
              var visitNumber = { visitNumber: visitId[2] };
              var serialNumber = { serialNumber: visitId[1] };

              var table = Object.assign(tableinit, visitNumber, serialNumber);

              // alert(table)
              this.TableData = table;
              // console.log(this.TableData);
              this.setState({
                DataLoaded: true,
              });

              // var searchRow = '<tr><td>'+number+'</td> <td>'+res.data[i]['Name']+'</td><td>'+res.data[i]['Age']+'</td><td>'+res.data[i]['Profession']+'</td><td>'+res.data[i]['MaritalStatus']+'</td><td>'+res.data[i]['Address']+'</td><td>'+res.data[i]['Tel ']+'</td><td>'+res.data[i]['Nationality']+'</td><td>'+date+'</td><td>'+time+'</td><td>'+visitNumber+'</td><td>'+serialNumber+'</td><td></td><td></td><td><a className="btn btn-primary startTreatment" id="'+res.data[i]['visitid']+'">Start Treatment</a></td></tr>'
              // $('.searchClass').append(searchRow)
            }
          }
        }

        //   if(res.data['status'])
        //   {
        //     $('.sendModuleSuccess').show()
        //     setTimeout(function (props) {
        //         $('.modal').hide()
        //          // this.props.history.push('/reception/dashboard')
        //      }, 3000);
        //   }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
    };
    event.preventDefault();
    console.log(this.state);
    axios
      .post(this.api_url+"triage/general/main", this.state, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    // Complications = request.json["Complications"],
    // PregnancyDate = request.json["PregnancyDate"],
    // EvolutionAndTreatment = request.json["EvolutionAndTreatment"],

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { Complications, PregnancyDate, EvolutionAndTreatment } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "Name",
          field: "Name",
          sort: "asc",
          width: 50,
        },
        {
          label: "Age",
          field: "Age",
          sort: "asc",
          width: 50,
        },
        {
          label: "Profession",
          field: "Profession",
          sort: "asc",
          width: 50,
        },
        {
          label: "Marital Status",
          field: "MaritalStatus",
          sort: "asc",
          width: 50,
        },
        {
          label: "Address",
          field: "Address",
          sort: "asc",
          width: 50,
        },
        {
          label: "Mobile Phone Number",
          field: "Tel ",
          sort: "asc",
          width: 50,
        },
        {
          label: "Nationality",
          field: "Nationality",
          sort: "asc",
          width: 50,
        },

        {
          label: "Date and Time Sent From Reception",
          field: "timeofopen",
          sort: "asc",
          width: 50,
        },
        {
          label: "Payment Status",
          field: "paymentsstatus",
          sort: "asc",
          width: 50,
        },

        // {
        //   
        //     field: "EvolutionAndTreatment",
        //     sort: "asc",
        //     width: 50
        // },
        {
          label: "Status",
          field: "modulestatus",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers />

        <main>
          <div className="container p-2">
            <form>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>
                <MDBDataTable striped bordered data={tabledata} />
              </div>
            </form>
          </div>
        </main>
        <div className="modal patientDetails" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title patientName"> </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Number Of Visit: <span className="NumberOfVisit"></span>
                </p>
                <p>
                  Serial of Number: <span className="SerialNumber"></span>
                </p>
                <button className="btn btn-success startTreatment">
                  Start Treatment
                </button>
                <div
                  id="loginSuccess"
                  className="alert alert-success"
                  style={displayHidden}
                  role="alert"
                >
                  <strong>Success! </strong>Treatment Started Successfully
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DSearchInModule;
